import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import {
  decideApproval,
  getApprovalsQueryKey,
  listApprovals,
  type ApprovalItem,
  type DecideApprovalInput,
  type ListApprovalsFilters,
} from '../api/approvals.client.js';

export function useApprovals(filters: ListApprovalsFilters = {}) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useQuery({
    queryKey: getApprovalsQueryKey(workspaceId, filters),
    queryFn: () => listApprovals(filters),
    enabled: scope !== null,
  });
}

export function useApprovalDecisionMutation() {
  const queryClient = useQueryClient();
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';

  return useMutation<ApprovalItem, Error, DecideApprovalInput>({
    mutationFn: decideApproval,
    onSuccess: () => {
      // Решение меняет и сам список, и сущность, к которой относилось действие:
      // подтверждённая смена стадии сразу видна в сделках, обогащение — в контактах.
      void queryClient.invalidateQueries({ queryKey: ['approvals', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['deals', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['contacts', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['companies', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['tasks', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['documents', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['notes', workspaceId] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard', workspaceId] });
    },
  });
}
